import { MAX_FOLDER_PANE_WIDTH, MAX_LIST_VIEW_WIDTH } from '../internalConstants';
import { BrowserWidthBucket, getBrowserWidthBucket } from 'owa-layout';

/**
 * Gets the left nav max width for the current browser window width
 */
export function getLeftNavMaxWidth(): number {
    const browserWidthBucket = getBrowserWidthBucket();

    if (browserWidthBucket <= BrowserWidthBucket.From919_To999) {
        return 198;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1080_To1199) {
        return 236;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1366_To1399) {
        return 254;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1400_To1599) {
        return 300;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1600_Above) {
        return 320;
    }
    return MAX_FOLDER_PANE_WIDTH;
}

/**
 * Gets the list view max width for the current browser window width
 */
export function getListViewMaxWidth(): number {
    const browserWidthBucket = getBrowserWidthBucket();

    if (browserWidthBucket <= BrowserWidthBucket.From919_To999) {
        return 350;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1080_To1199) {
        return 380;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1366_To1399) {
        return 452;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1400_To1599) {
        return 540;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1600_Above) {
        return 574;
    }
    return MAX_LIST_VIEW_WIDTH;
}
